import { render, staticRenderFns } from "./TemplateManagement.vue?vue&type=template&id=6235f944&scoped=true"
import script from "./TemplateManagement.vue?vue&type=script&lang=js"
export * from "./TemplateManagement.vue?vue&type=script&lang=js"
import style0 from "./TemplateManagement.vue?vue&type=style&index=0&id=6235f944&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235f944",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6235f944')) {
      api.createRecord('6235f944', component.options)
    } else {
      api.reload('6235f944', component.options)
    }
    module.hot.accept("./TemplateManagement.vue?vue&type=template&id=6235f944&scoped=true", function () {
      api.rerender('6235f944', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wechatOpenPlatform/components/TemplateManagement.vue"
export default component.exports